import * as echarts from 'echarts'

export const op1=(title:any,source:any,unit:any)=>{


  const xdata:any=[];
  const ydata:any=[];

  Object.keys(source).map((key:any)=>{
    if(source[key]!==null){
      xdata.push(key);
      ydata.push(source[key])
    }
  })

  return  {
    title: [
      {
        text: title,
        top: 20,
        left: "center",
        textStyle: {
          color: "#000",
          fontSize:20
        },
      },
    ],
    grid: {
      top: 70,
      left:110,
      bottom: 60,
    },
    tooltip: {
      trigger: "axis",
      axisPointer: {
        type: "cross",
        animation: false,
        label: {
          backgroundColor: "#505765",
        },
      },
    },
    // legend: {
    //   data: ["监测值"],
    //   right: 50,
    //   icon: "circle",
    // },
    xAxis: [
      {
        type: "category",
        boundaryGap: false,
        name: "温度 °C",
        nameGap:30,
        nameTextStyle:{
          fontSize:18,
          color:'#000'
        },
        nameLocation: "middle",
        splitLine: { show: true },
        axisLabel: {
          fontSize: 14,
        },
        data: xdata,
      },
    ],
    yAxis: [
      {
        type: "value",
        name: unit,
        nameTextStyle:{
          fontSize:14,
          // color:'#000'
        },
        // min: min2,
        // max: max2,
        nameGap:10,
        splitNumber: 10,
        axisLabel: {
          fontSize: 14,
        },
      },
    ],
    series: [
      // {
      //   name: "校准值",
      //   type: "line",
      //   // areaStyle: {},
      //   xAxisIndex: 0,
      //   lineStyle: {
      //     width: 1,
      //   },
      //   emphasis: {
      //     focus: "series",
      //   },
      //   data: ycdata,
      //   symbolSize: 8,
      //   lineStyle: {
      //     width: 3,
      //     shadowColor: "rgba(0,0,0,0.3)",
      //     shadowBlur: 3,
      //     shadowOffsetY: 3,
      //   },
      //   areaStyle: {
      //     color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
      //       {
      //         offset: 0,
      //         color: "rgba(22, 255, 255, 0.1)",
      //       },
      //       {
      //         offset: 1,
      //         color: "rgba(252, 255, 255,0.1)",
      //       },
      //     ]),
      //   },
      // },

      {
        
        type: "line",
        symbolSize: 5,
        // yAxisIndex: 1,
        // areaStyle: {},
        itemStyle: {
          color: "rgba(246, 163, 97,1)",
        },
        lineStyle: {
          color: "rgba(246, 163, 97,1)",
          width: 3,
          shadowColor: "rgba(0,0,0,0.3)",
          shadowBlur: 3,
          shadowOffsetY: 3,
        },
        emphasis: {
          focus: "series",
        },
        areaStyle: {
          color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
            {
              offset: 0,
              color: "rgba(246, 163, 97, 0.1)",
            },
            {
              offset: 1,
              color: "rgba(252, 255, 255,0.1)",
            },
          ]),
        },
        data: ydata,
      },
    ],
  };

}